import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=938b784a&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b784a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('938b784a')) {
      api.createRecord('938b784a', component.options)
    } else {
      api.reload('938b784a', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=938b784a&scoped=true&", function () {
      api.rerender('938b784a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "core/plugin/toasts/vue/icon.vue"
export default component.exports